/* eslint-disable */
import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Form} from 'forms/rrf';
import {Modal} from 'react-bootstrap';
import RequiredInput from '../../common/form/elements/required-input';
import RequiredTextarea from '../../common/form/elements/required-textarea';
import ArrowButton from '../../common/button-arrow';

class MessageDialog extends Component {
  containerRef = createRef();

  render() {
    const {onClose, onMessageSend, formValid, to} = this.props;
    
    return (
      
      <div ref={this.containerRef} className="modal-container">
      <Modal
        show={true}
        container={this.containerRef}
        aria-labelledby="contained-modal-title"
      >
        <Modal.Header>
          <Modal.Title><h5>Send message to: {to}</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form model="deep.store_message" onSubmit={onMessageSend}>
            <RequiredInput model=".subject" placeholder="Subject" label="Subject"/>
            <RequiredTextarea model=".body" label="Message" placeholder="Type your message here..."/>
            <div className="mg-top-20" style={{height: 50}}>
              <ArrowButton
                color="grey"
                className="float-start"
                submit={false}
                arrow={false}
                disabled={false}
                onClick={() => onClose(false)}
              >
                Cancel
              </ArrowButton>
              
              <ArrowButton
                color="red"
                className="float-end"
                submit
                arrow={false}
                disabled={!formValid}
              >
                Send
              </ArrowButton>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      </div>
    );
  }
}

MessageDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  formValid: state.deep.forms.store_message.$form.valid,
});

export default connect(mapStateToProps)(MessageDialog);
